import React from 'react';
import { connect } from 'react-redux';
import {
  getAdminState,
  getAuthState,
  getOnboardingState,
  getTenantState,
} from '../../store/selectors';
import {
  getAllTenants,
  getCareerBasicsForTenant,
  getDegreeBasicsForTenant,
} from '../../store/actions';
import Chevron from '../user-dashboard/utility/Chevron';
import BoxWithShadow from './basic-style-components/BoxWithShadow';
import CareerDegreeBarDropdown from './CareerDegreeBarDropdown';
import Loading from '../utility/Loading';
import FuzzySearchBar from '../career-search/FuzzySearchBar';

export class CareersDegreesTabs extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      tenants: [],
      showDropdown: false,
      chosenTenant: {},
      data: [],
      listToSearch: [],
      loading: true,
    };
  }

  componentDidMount = async () => {
    const data = await this.getDataForTenant();
  };

  getDataForTenant = async () => {
    let data = [];
    if (this.props.data === 'careers') {
      data = await this.props.getCareerBasicsForTenant(this.props.tenant.id);
    } else if (this.props.data === 'degrees') {
      data = await this.props.getDegreeBasicsForTenant(this.props.tenant.id);
    }
    if (this.props.advisorRole !== 'Super User') {
      this.setState({
        data,
        listToSearch: data,
        chosenTenant: {
          id: this.props.tenant.id,
          name: this.props.tenant.name,
          primary: this.props.tenant.primary,
          secondary: this.props.tenant.secondary,
          features: this.props.tenant.features,
        },
        loading: false,
      });
    } else {
      const tenants = await this.props.getAllTenants();
      this.setState({
        tenants,
        data,
        listToSearch: data,
        chosenTenant: {
          id: this.props.tenant.id,
          name: this.props.tenant.name,
          primary: this.props.tenant.primary,
          secondary: this.props.tenant.secondary,
          features: this.props.tenant.features,
        },
        loading: false,
      });
    }
  };

  selectedTenantStyle = (primary, secondary) => {
    return {
      color: primary,
      borderBottom: `2px solid ${secondary}`,
    };
  };

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  backgroundPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  backgroundSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  borderBottom = {
    borderBottom: `4px solid ${this.props.tenant.secondary}`,
  };

  navBarIcon = {
    height: '27px',
    width: '25px',
  };

  activeElement = {
    color: `${this.props.tenant.primary}`,
    borderBottom: `3px solid ${this.props.tenant.secondary}`,
  };

  borderTopSecondary = {
    borderTop: `9px solid ${this.props.tenant.secondary}`,
  };

  toggleShowDropdown = (val) => {
    this.setState({
      showDropdown: val,
    });
  };

  getDataForNewTenant = async (tenantId) => {
    let data = [];
    if (this.props.data === 'careers') {
      data = await this.props.getCareerBasicsForTenant(tenantId);
    } else if (this.props.data === 'degrees') {
      data = await this.props.getDegreeBasicsForTenant(tenantId);
    }
    this.setState({
      data,
      listToSearch: data,
      loading: false,
    });
  };

  setChosenTenant = (tenant) => {
    const { chosenTenant } = this.state;
    if (tenant.id !== chosenTenant.id) {
      this.setState(
        {
          chosenTenant: tenant,
          loading: true,
        },
        () => {
          this.getDataForNewTenant(tenant.id);
        }
      );
    }
  };

  setData = (data) => {
    this.setState({
      data,
    });
  };

  setOptionsLoading = (bool) => {
    this.setState({
      loading: bool,
    });
  };

  render() {
    const { tenants, showDropdown, chosenTenant, data, loading } = this.state;
    return (
      <div className="careers-tab" id="careers-tab">
        <div className="careers-tab__tenants-and-search-container">
          {this.props.advisorRole === 'Super User' &&
            !!chosenTenant &&
            !!tenants && (
              <div className="careers-tab__tenants-container">
                <div
                  className="careers-tab__tenants-button"
                  onClick={() => this.toggleShowDropdown(!showDropdown)}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.key))
                      this.toggleShowDropdown(!showDropdown);
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={`Select a tenant. Current tenant selected: ${chosenTenant}`}
                >
                  <div className="careers-tab__tenants-button-text">
                    {chosenTenant.name}
                  </div>
                  <Chevron
                    transform={
                      showDropdown ? 'rotate(270deg)' : 'rotate(90deg)'
                    }
                  />
                </div>
                {showDropdown && (
                  <div className="careers-tab__tenants-dropdown">
                    {tenants.map((tenant) => {
                      return (
                        <button
                          type="button"
                          className="careers-tab__tenants-option-button"
                          onClick={() => {
                            this.setChosenTenant(tenant);
                          }}
                          key={tenant.id}
                          tabIndex={0}
                          role="menuitem"
                          onKeyDown={(e) => {
                            if (['Enter'].includes(e.key)) {
                              this.setChosenTenant(tenant);
                            }
                          }}
                        >
                          <p
                            className="careers-tab__tenants-option-label"
                            style={
                              tenant.name === chosenTenant.name
                                ? this.selectedTenantStyle(
                                    tenant.primary,
                                    tenant.secondary
                                  )
                                : null
                            }
                          >
                            {tenant.name}
                          </p>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          <FuzzySearchBar
            inputText="Search"
            tenant={this.props.tenant}
            listToSearch={this.state.listToSearch}
            sendFilteredListToParent={this.setData}
            setSearchListLoadingOnParent={this.setOptionsLoading}
            searchKeys={['titleEn']}
          />
        </div>
        {loading && (
          <BoxWithShadow>
            <Loading height="100%" />
          </BoxWithShadow>
        )}
        {data.length > 0 && !loading && (
          <BoxWithShadow>
            {data.map((x) => (
              <CareerDegreeBarDropdown
                data={x}
                key={x.id}
                chosenTenant={chosenTenant}
                careerOrDegree={this.props.data}
              />
            ))}
          </BoxWithShadow>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const admin = getAdminState(state);
  const advisorRole = getOnboardingState(state).userData.user.role;
  const auth = getAuthState(state);
  const tenant = getTenantState(state);

  return { admin, auth, advisorRole, tenant };
}

export default connect(mapStateToProps, {
  getAllTenants,
  getCareerBasicsForTenant,
  getDegreeBasicsForTenant,
})(CareersDegreesTabs);
